import { logos } from '@logocode/logo-design-engine'
import logger from '../lib/logger'

export default (context, inject) => {
  logger.debug('Plugin: Injecting lde and svgjs.')
  inject('lde', logos)
}
